import { render, staticRenderFns } from "./LinkAccounts.vue?vue&type=template&id=c8cfe74c"
import script from "./LinkAccounts.vue?vue&type=script&lang=js"
export * from "./LinkAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports